import { getAPIHeaders } from '@/services/api.service';

function mapSubscriptions(subscriptions) {
    return subscriptions.map((subscription) => {
        return {
            ...subscription,
            startDate: subscription.startDate ? new Date(subscription.startDate) : null,
            endDate: subscription.endDate ? new Date(subscription.endDate) : null,
            proposedAt: subscription.proposedAt ? new Date(subscription.proposedAt) : null,
            validatedAt: subscription.validatedAt ? new Date(subscription.validatedAt) : null,
            signedAt: subscription.signedAt ? new Date(subscription.signedAt) : null,
            levies: subscription.levies
                ? JSON.parse(subscription.levies).map((levy) => ({ date: new Date(levy.date), amount: levy.amount }))
                : [],
        };
    });
}
function mapOrganization(item) {
    return item
        ? {
              ...item,
              createdAt: item.createdAt ? new Date(item.createdAt) : null,
              createdBy: item.createdBy ? new Date(item.createdBy) : null,
              updatedAt: item.updatedAt ? new Date(item.updatedAt) : null,
              updatedBy: item.updatedBy ? new Date(item.updatedBy) : null,
              startDate: item.startDate ? new Date(item.startDate) : null,
              endDate: item.endDate ? new Date(item.endDate) : null,
              subscriptions: mapSubscriptions(item.subscriptions),
          }
        : null;
}
function mapOrganizationBilling(item) {
    return item
        ? {
              ...item,
              createdAt: item.createdAt ? new Date(item.createdAt) : null,
              createdBy: item.createdBy ? new Date(item.createdBy) : null,
              updatedAt: item.updatedAt ? new Date(item.updatedAt) : null,
              updatedBy: item.updatedBy ? new Date(item.updatedBy) : null,
              billingDate: item.billingDate ? new Date(item.billingDate) : null,
              validatedOn: item.validatedOn ? new Date(item.validatedOn) : null,
              expireAt: item.expireAt ? new Date(item.expireAt) : null,
          }
        : null;
}

export async function removeOrganization(organization) {
    const response = await fetch(
        new Request(`/api/organizations/${organization.id}`, {
            method: 'DELETE',
            headers: getAPIHeaders(),
        }),
    );
    return response.json();
}

export async function createOrganization(ownerEmail) {
    const response = await fetch(
        new Request(`/api/organizations`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify({ ownerEmail }),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('replication pull failed');
    }
}

export async function updateOrganization(organization) {
    const response = await fetch(
        new Request(`/api/organizations/${organization.id}`, {
            method: 'PUT',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(organization),
        }),
    );
    return mapOrganization(await response.json());
}
export async function getOrganizations() {
    const response = await fetch(`/api/organizations`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).map(mapOrganization);
}
export async function getOrganization(organizationId) {
    const response = await fetch(`/api/organizations/${organizationId}`, {
        headers: getAPIHeaders(),
    });
    return mapOrganization(await response.json());
}
export async function getOrganizationBillings(organizationId) {
    const response = await fetch(`/api/organizations/${organizationId}/billings`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).map(mapOrganizationBilling);
}
export async function getOrganizationProjects(organizationId) {
    const response = await fetch(`/api/organizations/${organizationId}/projects`, {
        headers: getAPIHeaders(),
    });
    return response.json();
}

export async function getOrganizationUsers(organizationId) {
    const response = await fetch(`/api/organizations/${organizationId}/users`, {
        headers: getAPIHeaders(),
    });
    return response.json();
}

export async function updateOrganizationUser(organizationId, user) {
    const response = await fetch(`/api/organizations/${organizationId}/users/${user.id}`, {
        headers: getAPIHeaders({ 'content-type': `application/json` }),
        method: 'PUT',
        body: JSON.stringify(user),
    });
    return response.json();
}

export async function insertOrganizationUser(organizationId, user) {
    const response = await fetch(`/api/organizations/${organizationId}/users`, {
        headers: getAPIHeaders({ 'content-type': `application/json` }),
        method: 'POST',
        body: JSON.stringify(user),
    });
    return response.json();
}

export function removeOrganizationUser(organizationId, userId) {
    return fetch(`/api/organizations/${organizationId}/users/${userId}`, {
        headers: getAPIHeaders({ 'content-type': `application/json` }),
        method: 'DELETE',
    });
}
